import Vue from 'vue'
import VueRouter from 'vue-router'
import { firestorePlugin } from 'vuefire';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import Slider from './slider'
import ToggleNav from './navbar'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://93bfbecccf474d41ba40a25272acc6cc@sentry.io/1785915',
        integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
    });
}

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(firestorePlugin);
require('./filters');

/**
 * Register all Vue components
 */
const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Slider();
ToggleNav();

const el = document.getElementById('app');
if (el) {
    const router = new VueRouter({
        mode: 'history',
    });
    const app = new Vue({
        el,
        router,
    });
}
